import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {ProductResourcesComponent} from './product-resources.component';
import {ProductResourceTileComponent} from './product-resource-tile/product-resource-tile.component';
import {MediaModule} from '@spartacus/storefront';

import {ProductSingleResourceTileComponent} from './product-single-resource-tile/product-single-resource-tile.component';
import {ProductTypeDisplayComponent} from './product-type-display/product-type-display.component';
import {ProductTileContentComponent} from './product-tile-content/product-tile-content.component';
import {TermsAndConditionsModule} from '@app/checkout/checkout-terms-conditions/terms-and-conditions.module';
import '@sapudex/web-components/dist/Button.js';

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductResourcesComponent: {
          component: ProductResourcesComponent,
        },
      },
    }),
    I18nModule,
    MediaModule,
    TermsAndConditionsModule,
    ProductResourceTileComponent,
    ProductSingleResourceTileComponent,
    ProductTileContentComponent,
    ProductTypeDisplayComponent,
    ProductResourcesComponent,
  ],
  exports: [ProductResourcesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ResourcesModule {}
